import Card from 'react-bootstrap/Card';
import { Row, Col, Placeholder } from 'react-bootstrap';
import placeholderImage from "../assets/Placeholder.png"

const RoomCardHorizontal = () => {
  return (
    <Row className="d-flex justify-content-start">
      <Col xs={6} lg={6}>
        <Card 
          className="bg-white shadow-sm md p-0 mt-4" 
          style={{ cursor: 'pointer', height: '14rem' }}
        >
          <Card.Img variant="top" src={placeholderImage} style={{height: '14rem', borderRadius: '5px'}} alt="RoomCardHorizontalCarouselImage"/>
        </Card>
      </Col>

      <Col xs={6} lg={6}>
        <Card 
          className="bg-white shadow-sm md mt-4 p-2" 
          style={{ cursor: 'pointer', height: '14rem' }}
        >
          <Card.Body className="p-1 mt-1">
            <Placeholder as={Card.Title} animation="glow">
              <Placeholder xs={6} />
            </Placeholder>

            <Placeholder as={Card.Text} animation="glow">
              <Placeholder xs={10} />
              <Placeholder xs={10} />
            </Placeholder>

            <hr style={{width: '90%', marginLeft: '1.2rem', marginTop: '2rem'}}/>

            <Placeholder as={Card.Text} animation="glow">
              <Placeholder xs={10} />
              <Placeholder xs={10} />
            </Placeholder>
          </Card.Body>
        </Card>
        </Col>
    </Row>
  )
}

export default RoomCardHorizontal